"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cyZones = void 0;
var cyZones = exports.cyZones = [{
  id: 'NICOSIE',
  name: 'Nicosie',
  country: 'CY',
  cornerNW: {
    latitude: 35.2152,
    longitude: 33.2820
  },
  cornerSE: {
    latitude: 35.0853,
    longitude: 33.4241
  },
  subZones: [{
    name: 'Nicosia Centre historique',
    zipcodes: {
      1065: {
        label: '1065'
      }
    }
  }, {
    name: 'Nicosia Quartier gouvernemental',
    zipcodes: {
      1101: {
        label: '1101'
      }
    }
  }, {
    name: 'Nicosia nord',
    zipcodes: {
      1025: {
        label: '1025'
      }
    }
  }, {
    name: 'Nicosia Quartier commercial',
    zipcodes: {
      2058: {
        label: '2058'
      }
    }
  }]
}];